import { Injectable } from '@angular/core';
import { DataTransformAbstractPost } from 'app/modules/global/classes/data.transform.abstract.down';
import { FieldInterface } from 'app/modules/common/inputs/custom-fields/fields/fields.interface';
import { FluidDatePipe } from 'app/modules/global/pipes/fluidDate.pipe';
import { FeeditemInterface } from 'app/models/feed.model';

@Injectable({
  providedIn: 'root',
})
export class FeeditemDataTransformPost extends DataTransformAbstractPost {
  constructor(protected readonly _fluidDatePipe: FluidDatePipe) {
    super();
  }

  transform(el: FeeditemInterface): FeeditemInterface {
    console.log('FeeditemDataTransformPost', el);
    // const fields = el.feed.parent ? el.feed.parent.fields : el.feed.fields;
    // this.normalizeFields(fields, el);
    return el;
  }

  protected normalizeFields(contents: FieldInterface[], element: FeeditemInterface): FieldInterface[] {
    if (!Array.isArray(contents)) {
      return contents;
    }
    contents.forEach((field: FieldInterface) => {
      if (field.type === 'input' && element.data?.[field.key]) {
        if (field.templateOptions.type === 'date') {
          console.log('>>> UPLOAD element date transform');
          element.data[field.key] = this.normalizeTime(element.data[field.key].toString());
        }
        if (field.templateOptions.type === 'month') {
          element.data[field.key] = this.normalizeTime(element.data[field.key].toString());
        }
        if (field.templateOptions.type === 'time') {
          element.data[field.key] = this.normalizeTime(element.data[field.key].toString());
        }
      }
    });
    return contents;
  }
}
